import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import GlassSurface from './GlassSurface/GlassSurface';
import './Header.css';
import logo from '../ressources1/Logo-JSD-BlancV2.png';

const Header = memo(({ theme = 'dark' }) => {
  const isDark = theme === 'dark';
  
  return (
    <header className="header-wrapper">
      <div className="header-container">
        <GlassSurface
          width="100%"
          height={80}
          borderRadius={40}
          borderWidth={0.05}
          brightness={60}
          opacity={0.85}
          blur={15}
          className="header-glass"
        >
          <nav className="nav-content">
            <Link to="/" className="logo">
              <img 
                src={logo} 
                alt="Logo JSD"
                style={{
                  filter: isDark ? 'none' : 'brightness(0) opacity(0.85)',
                  transition: 'filter 0.3s ease'
                }}
              />
            </Link>
            <ul className="nav-links">
              <li>
                <Link 
                  to="/work"
                  style={{ 
                    color: isDark ? 'white' : 'rgba(0, 0, 0, 0.85)',
                    transition: 'color 0.3s ease'
                  }}
                >
                  Réalisations
                </Link>
              </li>
              <li>
                <Link 
                  to="/services"
                  style={{ 
                    color: isDark ? 'white' : 'rgba(0, 0, 0, 0.85)',
                    transition: 'color 0.3s ease'
                  }}
                >
                  Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact"
                  style={{ 
                    color: isDark ? 'white' : 'rgba(0, 0, 0, 0.85)',
                    transition: 'color 0.3s ease'
                  }}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
        </GlassSurface>
      </div>
    </header>
  );
});

Header.displayName = 'Header';

export default Header;
